/******************************************************
 *                  Admin Export Ctrl
 ********************************************************/

"use strict";

angular.module("open-iti")

	.controller("OpenPublicationCtrlNew", [
		"$scope", "OpenPublicationService", "Utils", "NetworkService", "$location", "toastr",
		function ($scope, OpenPublicationService, Utils, NetworkService, $location, toastr) {


		$scope.data = {
			checkbox: true,
			exportGtfs: true,
			exportNeptune: true,
			exportKml: false,
			exportNetex: false,
			publicationGoogle: true,
			linesToExport: {},
			formats: "",
			nameNetworkSelected : "",
			typeLicence: "open"
		};


		$scope.$watch("data.currentNetwork", function() {
			if($scope.data.currentNetwork !== undefined){
				NetworkService.findNetworkById($scope.data.currentNetwork).then((response) => {
					$scope.data.nameNetworkSelected = "Réseau "+response.data.name;
				});
			}
		});


		// Initaliser les listes du choix de l'utilisateur
		$scope.initListes = function () {
			$scope.data.linesToExport = {};
			$scope.addAllLineToOneModelExport();
		};

		// Ajouter une ligne à exporter
		$scope.DefinirLineToExport = function (line, statut) {
			$scope.data.linesToExport[line.id] = statut;
		};

		// Changer l'état d'une ligne à exporter
		$scope.changeStateExportLine = function (line) {

			if (!$scope.data.linesToExport[line.id]) {
				// Ajout de la ligne dans la liste
				$scope.DefinirLineToExport(line, true);
			} else {
				// Désactiver la ligne de la liste
				$scope.DefinirLineToExport(line, false);
			}

		};

		// Ajouter toutes les lignes à une liste d'export
		$scope.addAllLineToOneModelExport = function () {
			for (var i = 0; i < $scope.data.lines.length; i++) {
				$scope.DefinirLineToExport($scope.data.lines[i], true);
			}
		};

		$scope.changeStateCheckbox = function () {
			if ($scope.data.checkbox) {
				$scope.data.checkbox = false;
				$scope.data.linesToExport = {};
			} else {
				$scope.data.checkbox = true;
				$scope.addAllLineToOneModelExport();
			}
		};


		// MHI
		$scope.publishData = function () {

			// Ajouter les formats d'exports
			var formats = [];
			if ($scope.data.exportGtfs) {
				formats.push("GTFS");
			}
			if ($scope.data.exportNeptune) {
				formats.push("Neptune");
			}
			if ($scope.data.exportKml) {
				formats.push("KML");
			}
			if ($scope.data.exportNetex) {
				formats.push("Netex");
			}


			$scope.data.formats = Utils.convertValueTabToStringWithComma(formats);
			$scope.data.linesString = Utils.convertIndexTabToStringWithComma($scope.data.linesToExport);

			if($scope.data.formats.length !== 0 && !$scope.isEmpty($scope.data.linesToExport)){
				OpenPublicationService.postPublication($scope.data)
					.then(() => {
						toastr.success("La mise en ligne sera effectuée dans quelques minutes", "Analyse avant publication");
						$location.path("/open-iti/publication");
					})
					.catch((error) => {
						const data = error.data;
						let errorMessage = "Problème lors de la publication.";
						if (data !== undefined && data.message) {
							errorMessage += "\n" + data.message;
						}
						toastr.error(errorMessage, "Erreur");
					});
			}
			else{
				if($scope.data.formats.length === 0 && !$scope.isEmpty($scope.data.linesToExport)){
					toastr.error("Veuillez choisir un format d'export");
				}
				else if($scope.data.formats.length !== 0 && $scope.isEmpty($scope.data.linesToExport)){
					toastr.error("Veuillez choisir une/des ligne(s) à exporter");
				}
				else{
					toastr.error("Veuillez choisir un format d'export et une/des ligne(s) à exporter");
				}
			}
		};

	  $scope.uploadFileLicence = function (files) {
		  if (files[0].size > 10000000) {
			  toastr.error("Le poid de votre ficher de licence est trop important.", "Taille de votre fichier de licence");
			  angular.element("input[type='file']").val(null);
		  }
		  else if ((files[0].name).substr(-3) !== "pdf"){
			  toastr.error("Ce format de fichier n'est pas accepté. Veuillez importer un fichier de type PDF");
			  angular.element("input[type='file']").val(null);
		  }
	  };

	}]
	)
;
